// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"364":"2a230a139594f678","888":"7037621d2ed6d0b5"}[chunkId] + ".css";
};